import React from 'react'
import styles from '../../styles/home.module.css';
import { IMAGEPATH } from '../../constants/imagePath';
import SectionTitle from '../common/SectionTitle';
import SectionTitleSub from '../common/SectionTitleSub';
import { KR } from '../../constants/localizations';

export default function HomeProductSection() {
    return (
        <div className={styles.product}>
            <SectionTitle title={KR.label_home_product_overview} titleEng={KR.label_home_product_overview_eng} />
            <SectionTitleSub content={"자동화된 운행 시스템과 정밀한 경로 탐색 능력을 통해 물류, 제조, 스마트 시티 등 다양한 산업 분야에서 효율성과 안전성을 제공합니다."} contentEng={"Providing efficiency and safety across various industries, including logistics, manufacturing, and smart cities, through an automated driving system and precise route navigation capabilities."} />
            <div className={styles.cardW}>
                <div className={styles.card}>
                    <img src={IMAGEPATH.robots1} srcSet={IMAGEPATH.robots1Webp} alt="ar247_robots" loading="lazy" />
                    <div>
                        <span>{KR.label_home_delivery_robot}</span>
                        {KR.label_home_delivery_robot_detail}
                    </div>
                </div>
                <div className={styles.card}>
                    <img src={IMAGEPATH.robots2} srcSet={IMAGEPATH.robots2Webp} alt="ar247_robots" loading="lazy" />
                    <div>
                        <span>{KR.label_home_logi_robot}</span>
                        {KR.label_home_logi_robot_detail}
                    </div>
                </div>
                <div className={styles.card}>
                    <img src={IMAGEPATH.solution} srcSet={IMAGEPATH.solutionWebp} alt="ar247_solution" loading="lazy" />
                    <div>
                        <span>{KR.label_home_total_solution}</span>
                        <p>
                            {KR.label_home_total_solution_detail}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
